// VCM Project I — WK-23: toggle the pre-rendered per-width matching-products panel
// when the shopper changes the Width option. Delegated listener, same pattern as
// the pdp_option_change tracking in variant-picker.liquid — no re-fetch needed since
// every width's panel is already in the DOM.
(function () {
  document.addEventListener('change', function (evt) {
    if (!evt.target.classList || !evt.target.classList.contains('js-option')) return;
    var fieldset = evt.target.closest('[data-option]');
    if (!fieldset || fieldset.dataset.option !== 'Width') return;

    var value = evt.target.value;
    document.querySelectorAll('[data-wk-matching-products-wrap]').forEach(function (wrap) {
      wrap.querySelectorAll('[data-wk-width]').forEach(function (panel) {
        panel.hidden = panel.dataset.wkWidth !== value;
      });
    });
  });
})();
